<template>
  <div>
    <div
      v-if="isMinimized"
      class="floating-toggle-btn"
      @click="restoreWindow"
      title="在线客服"
    >
      <div class="toggle-content">
        <svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor" stroke="none" class="chat-icon-svg">
          <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
        </svg>
      </div>
      <span class="notification-dot"></span>
      <span class="ping-effect"></span>
    </div>

    <transition v-else name="chat-window-fade">
      <div class="chat-window">
        <div class="chat-header">
          <div class="header-decoration"></div>

          <div class="header-content">
            <div class="header-title-area">
              <div class="bot-icon-wrapper">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-white"><rect x="3" y="11" width="18" height="10" rx="2"></rect><circle cx="12" cy="5" r="2"></circle><path d="M12 7v4"></path><line x1="8" y1="16" x2="8" y2="16"></line><line x1="16" y1="16" x2="16" y2="16"></line></svg>
              </div>
              <div class="header-text">
                <span class="brand-name">{{ site_brand_name || 'SPSSAI' }} 智能客服</span>
                <div class="status-badge">
                  <span class="status-dot"></span>
                  在线中
                </div>
              </div>
            </div>

            <div class="header-actions">
              <div
                class="custom-tooltip-wrapper"
                @mouseover="showTooltip"
                @mouseleave="hideTooltip"
              >
                <span
                  v-if="isUserLoggedIn"
                  class="action-btn"
                  @click="resetChat"
                  title="重置"
                >
                  <i class="el-icon-brush"></i>
                </span>
              </div>
              <span class="action-btn" @click="minimizeWindow">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line></svg>
              </span>
              <span class="action-btn" @click="minimizeWindow">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
              </span>
            </div>
          </div>
        </div>

        <div class="chat-body" ref="chatBodyRef">
          <div class="chat-timestamp">今天 {{ new Date().getHours() }}:{{ new Date().getMinutes().toString().padStart(2, '0') }}</div>

          <transition-group name="message-fade" tag="div">
            <div
              v-for="(msg, index) in initialMessages"
              :key="`initial-${index}`"
              class="message ai-message"
            >
              <div class="avatar-container ai-avatar-style">AI</div>

              <div
                v-if="msg.type === 'login-prompt'"
                class="message-content login-prompt-message"
              >
                <p>{{ msg.content }}</p>
                <button @click="openLoginPopup">点击登录</button>
              </div>

              <div
                v-else-if="msg.type === 'welcome'"
                class="message-content welcome-message"
              >
                <p>{{ msg.content }}</p>
                <div
                  v-if="msg.questions.length > 0"
                  class="suggested-questions"
                >
                  <button
                    v-for="q in msg.questions"
                    :key="q"
                    @click="sendSuggestedQuestion(q)"
                  >
                    {{ q }}
                  </button>
                </div>
              </div>

              <div v-else class="message-content" v-html="msg.content"></div>
            </div>
          </transition-group>

          <div
            v-for="(msg, index) in messages"
            :key="index"
            class="message"
            :class="msg.role === 'user' ? 'user-message' : 'ai-message'"
          >
            <template v-if="msg.role !== 'user'">
              <div class="avatar-container ai-avatar-style">AI</div>
              <div class="message-content" v-html="msg.content"></div>
            </template>

            <template v-else>
              <div class="message-content" v-html="msg.content"></div>
              <el-avatar
                :size="36"
                :src="userInfo && userInfo.avatar"
                class="avatar user-avatar"
              >
                {{
                  (userInfo &&
                    userInfo.nickname &&
                    userInfo.nickname.charAt(0)) ||
                  '用户'
                }}
              </el-avatar>
            </template>
          </div>

          <div v-if="isLoading" class="message ai-message">
            <div class="avatar-container ai-avatar-style">AI</div>
            <div class="message-content typing-indicator">
              <span></span><span></span><span></span>
            </div>
          </div>
        </div>

        <div class="chat-footer">
          <div class="input-wrapper">
            <input
              v-model="userInput"
              type="text"
              class="chat-input"
              :placeholder="
                isUserLoggedIn ? '输入您的问题...' : '请先登录后开始对话'
              "
              @keyup.enter="sendMessage"
              :disabled="isInputDisabled"
            />
          </div>
          <button
            class="send-button"
            @click="sendMessage"
            :disabled="isInputDisabled"
          >
            <svg
              viewBox="0 0 24 24"
              width="16"
              height="16"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="22" y1="2" x2="11" y2="13"></line>
              <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
            </svg>
          </button>
        </div>
      </div>
    </transition>

    <transition name="tooltip-fade">
      <div
        v-if="tooltipState.visible"
        class="custom-tooltip-fixed"
        :style="{
          top: `${tooltipState.top}px`,
          left: `${tooltipState.left}px`
        }"
      >
        重置对话
      </div>
    </transition>

    <LoginPopup :visible="isLoginPopupVisible" @close="closeLoginPopup" />
  </div>
</template>

<script>
import { getAIChatStream, getAIChatConfig } from '@/api/aiChat'
import { wechatQrcodes, ensureWechatQrcodes } from '@/utils/wechatQrcodes.js'
import MarkdownIt from 'markdown-it'
import { mapState } from 'vuex'
import LoginPopup from './WeChatLoginPopup.vue'

const md = new MarkdownIt()
// 移除了 aiAvatar 变量，因为已改为 CSS 样式实现

export default {
  name: 'AIChatWindow',

  components: {
    LoginPopup
  },

  data() {
    return {
      userInput: '',
      messages: [],
      isLoading: false,
      isMinimized: false,
      initialMessages: [],
      isWelcoming: false,
      isLoginPopupVisible: false,

      tooltipState: {
        visible: false,
        top: 0,
        left: 0
      },

      md: md
    }
  },

  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo,
      site_brand_name: state => state.site?.siteInfo?.site_brand_name || ''
    }),

    isUserLoggedIn() {
      return !!this.userInfo
    },
    isInputDisabled() {
      return this.isLoading || this.isWelcoming || !this.isUserLoggedIn
    }
  },

  watch: {
    isUserLoggedIn(isNowLoggedIn, wasPreviouslyLoggedIn) {
      // 登录后：展开窗口并重置聊天
      if (isNowLoggedIn && !wasPreviouslyLoggedIn) {
        this.isMinimized = false
        this.resetChat()
      }
      // 退出登录后：重置聊天状态
      if (!isNowLoggedIn && wasPreviouslyLoggedIn) {
        this.resetChat()
      }
    }
  },

  mounted() {
    this.playWelcomeAnimation()
  },

  methods: {
    // ===== 登录弹窗逻辑 =====
    openLoginPopup() {
      this.isLoginPopupVisible = true
    },
    closeLoginPopup() {
      this.isLoginPopupVisible = false
    },

    // ===== Tooltip 逻辑 =====
    showTooltip(event) {
      const rect = event.currentTarget.getBoundingClientRect()
      this.tooltipState.top = rect.top - 10
      this.tooltipState.left = rect.left + rect.width / 2
      this.tooltipState.visible = true
    },
    hideTooltip() {
      this.tooltipState.visible = false
    },

    // ===== 辅助方法 =====
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    },

    // ===== 核心聊天逻辑 =====

    async playWelcomeAnimation() {
      if (this.isWelcoming || this.initialMessages.length > 0) return

      this.isWelcoming = true

      // 先获取AI配置，两种状态下都可能需要二维码信息
      const config = await getAIChatConfig()

      if (this.isUserLoggedIn) {
        // --- 已登录用户的逻辑 ---
        this.isLoading = true
        await this.sleep(1000)

        this.isLoading = false
        this.initialMessages.push({
          type: 'welcome',
          content: config.ai_welcome_text,
          questions: config.ai_suggested_questions || []
        })
        this.scrollToBottom()
        await this.$nextTick()
      } else {
        // --- 未登录用户的逻辑 ---
        this.isLoading = true
        await this.sleep(1000)
        this.isLoading = false

        // 消息1: 提示登录
        this.initialMessages.push({
          type: 'login-prompt',
          content: '登录后使用ai客服!'
        })
        this.scrollToBottom()
        await this.$nextTick()
      }

      // 对两种情况都显示二维码（优先 SDS-Admin C 端码 cEnd，回退 AI 配置码）
      await ensureWechatQrcodes()
      const qrSrc = wechatQrcodes.cEnd || config.ai_qr_code_url
      const qrText = config.ai_qr_code_text || '微信扫码 · 联系在线客服'
      if (qrSrc) {
        await this.sleep(600)
        this.isLoading = true
        await this.sleep(1200)

        this.isLoading = false
        this.initialMessages.push({
          type: 'qr',
          content: `
        <div class="qr-code-message">
          <img src="${qrSrc}" alt="客服二维码" />
          <p>${qrText}</p>
        </div>
      `
        })
        this.scrollToBottom()
        await this.$nextTick()
      }

      this.isWelcoming = false
    },

    scrollToBottom() {
      this.$nextTick(() => {
        if (this.$refs.chatBodyRef) {
          this.$refs.chatBodyRef.scrollTop = this.$refs.chatBodyRef.scrollHeight
        }
      })
    },

    resetChat() {
      this.messages = []
      this.initialMessages = []
      this.playWelcomeAnimation()
      this.scrollToBottom()
    },

    sendMessage() {
      const query = this.userInput.trim()
      if (!query || this.isInputDisabled) return

      this.messages.push({ role: 'user', content: query })
      this.userInput = ''
      this.scrollToBottom()

      this.isLoading = true

      let rawAiContent = ''

      getAIChatStream(
        query,
        (chunk) => {
          if (this.isLoading) {
            this.isLoading = false
            this.messages.push({ role: 'ai', content: '' })
          }

          rawAiContent += chunk

          const lastMessage = this.messages[this.messages.length - 1]
          if (lastMessage && lastMessage.role === 'ai') {
            lastMessage.content = this.md.render(rawAiContent)
          }

          this.scrollToBottom()
        },
        () => {
          this.isLoading = false
          this.scrollToBottom()
        },
        (error) => {
          this.isLoading = false
          this.messages.push({
            role: 'ai',
            content: `<span style="color: red;">抱歉，出错了：${error}</span>`
          })
          this.scrollToBottom()
        }
      )
    },

    sendSuggestedQuestion(question) {
      this.userInput = question
      this.sendMessage()
    },

    // ===== 窗口控制 =====
    minimizeWindow() {
      this.isMinimized = true
    },

    restoreWindow() {
      this.isMinimized = false
      if (this.initialMessages.length === 0) {
        this.playWelcomeAnimation()
      }
      this.scrollToBottom()
    },

    openWindow() {
      this.restoreWindow()
    }
  }
}
</script>

<style scoped>
/* ================= 全局动画定义 ================= */
@keyframes slideInUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

/* ================= 1. 悬浮启动球样式 (参考项目样式) ================= */
.floating-toggle-btn {
  position: fixed;
  right: 30px;
  bottom: 30px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4f46e5 0%, #2563eb 100%);
  box-shadow: 0 8px 30px rgba(79, 70, 229, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 9998;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  color: white;
}

.floating-toggle-btn:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 36px rgba(79, 70, 229, 0.5);
}

.floating-toggle-btn:active {
  transform: scale(0.92);
}

.toggle-content {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 红点通知 */
.notification-dot {
  position: absolute;
  top: 0;
  right: 0;
  width: 14px;
  height: 14px;
  background-color: #ef4444;
  border: 2px solid white;
  border-radius: 50%;
  z-index: 3;
}

/* 波动效果 (Ping) */
.ping-effect {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background-color: #818cf8; /* indigo-400 */
  opacity: 0;
  z-index: 1;
  animation: ping 2s cubic-bezier(0, 0, 0.2, 1) infinite;
}

@keyframes ping {
  75%, 100% {
    transform: scale(1.6);
    opacity: 0;
  }
  0% {
    transform: scale(1);
    opacity: 0.4;
  }
}

/* ================= 2. 聊天主窗口样式 ================= */
.chat-window {
  position: fixed;
  right: 30px;
  bottom: 30px;
  width: 360px;
  height: 580px;
  background-color: #fff;
  border-radius: 24px;
  box-shadow: 0 20px 50px -12px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 9999;
  border: 1px solid rgba(0,0,0,0.05);
}

.chat-window-fade-enter-active {
  animation: slideInUp 0.3s ease-out;
}
.chat-window-fade-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}
.chat-window-fade-leave-to {
  opacity: 0;
  transform: translateY(20px) scale(0.95);
}

/* ================= 头部样式 ================= */
.chat-header {
  position: relative;
  padding: 16px 20px;
  background: linear-gradient(to right, #4f46e5, #2563eb, #3b82f6);
  color: white;
  flex-shrink: 0;
  overflow: hidden;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.header-decoration {
  position: absolute;
  top: -40px;
  right: -40px;
  width: 128px;
  height: 128px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  filter: blur(24px);
  pointer-events: none;
}

.header-content {
  position: relative;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-title-area {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* 头部 Bot Icon 容器 (参考项目样式) */
.bot-icon-wrapper {
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(4px);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 0 0 1px rgba(255,255,255,0.1);
  flex-shrink: 0;
}

.header-text {
  display: flex;
  flex-direction: column;
}

.brand-name {
  font-weight: 700;
  font-size: 15px;
  letter-spacing: 0.025em;
  text-shadow: 0 1px 2px rgba(0,0,0,0.1);
}

.status-badge {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: #dbeafe;
}

.status-dot {
  width: 6px;
  height: 6px;
  background-color: #4ade80;
  border-radius: 50%;
  animation: pulse-dot 2s infinite;
}

@keyframes pulse-dot {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.header-actions {
  display: flex;
  gap: 4px;
  align-items: center;
}

.action-btn {
  padding: 6px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.9);
  transition: all 0.2s;
}

.action-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
}

/* ================= 内容区域样式 ================= */
.chat-body {
  flex-grow: 1;
  padding: 16px;
  overflow-y: auto;
  background-color: #f8fafc;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.chat-timestamp {
  text-align: center;
  font-size: 12px;
  color: #94a3b8;
  margin-bottom: 4px;
}

.message {
  display: flex;
  align-items: flex-start;
  max-width: 100%;
  animation: slideInUp 0.3s ease-out;
}

/* 对话中的 AI 头像样式 (参考项目) */
.avatar-container {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: bold;
  flex-shrink: 0;
  margin-top: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  margin-right: 8px;
}

.ai-avatar-style {
  background: linear-gradient(to bottom right, #6366f1, #3b82f6);
  color: white;
}

.user-avatar {
  margin-left: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.message-content {
  padding: 12px 16px;
  font-size: 14px;
  line-height: 1.5;
  word-wrap: break-word;
  max-width: 80%;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

/* AI 消息样式 */
.ai-message {
  justify-content: flex-start;
}
.ai-message .message-content {
  background-color: #ffffff;
  color: #334155;
  border: 1px solid #f1f5f9;
  border-radius: 16px;
  border-top-left-radius: 4px;
}

/* 用户 消息样式 */
.user-message {
  justify-content: flex-end;
}
.user-message .message-content {
  background-color: #4f46e5;
  color: #ffffff;
  border-radius: 16px;
  border-top-right-radius: 4px;
  box-shadow: 0 4px 6px -1px rgba(79, 70, 229, 0.2);
}

/* 消息内容中的链接/代码样式 */
.ai-message .message-content :deep(pre) {
  background-color: #1e293b;
  color: #e2e8f0;
  padding: 10px;
  border-radius: 8px;
  margin: 8px 0;
  overflow-x: auto;
}
.ai-message .message-content :deep(code) {
  font-family: monospace;
  background-color: rgba(0, 0, 0, 0.05);
  padding: 2px 4px;
  border-radius: 4px;
}

/* 二维码尺寸控制 */
.message-content :deep(.qr-code-message img) {
  width: 140px;
  height: 140px;
  object-fit: contain;
  display: block;
  margin: 0 auto 8px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}
.message-content :deep(.qr-code-message) {
  text-align: center;
  padding: 5px;
}
.message-content :deep(.qr-code-message p) {
  margin: 0;
  font-size: 13px;
  color: #64748b;
}

/* 欢迎消息与建议问题 */
.welcome-message p { margin-top: 0; }
.suggested-questions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}
.suggested-questions button {
  background-color: #fff;
  border: 1px solid #e0e7ff;
  color: #4f46e5;
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
}
.suggested-questions button:hover {
  background-color: #eef2ff;
  border-color: #a5b4fc;
}

/* 登录提示样式 */
.login-prompt-message button {
  background-color: #2563eb;
  color: white;
  border: none;
  padding: 6px 16px;
  border-radius: 999px;
  cursor: pointer;
  font-size: 13px;
  margin-top: 8px;
}

/* 打字动画 */
.typing-indicator span {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #cbd5e1;
  margin: 0 2px;
  animation: typing 1s infinite;
}
.typing-indicator span:nth-child(2) { animation-delay: 0.2s; }
.typing-indicator span:nth-child(3) { animation-delay: 0.4s; }
@keyframes typing {
  0%, 100% { opacity: 0.3; }
  50% { opacity: 1; }
}

/* ================= 底部输入区域 ================= */
.chat-footer {
  padding: 12px 16px;
  border-top: 1px solid #f1f5f9;
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #fff;
}

.input-wrapper {
  flex-grow: 1;
  position: relative;
}

.chat-input {
  width: 100%;
  box-sizing: border-box;
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  padding: 10px 16px;
  padding-right: 40px;
  font-size: 14px;
  transition: all 0.2s;
}

.chat-input:focus {
  outline: none;
  background-color: #fff;
  border-color: #818cf8;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.send-button {
  width: 36px;
  height: 36px;
  background-color: #4f46e5;
  color: white;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  flex-shrink: 0;
}

.send-button:hover:not(:disabled) {
  background-color: #4338ca;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);
  transform: scale(1.05);
}

.send-button:disabled {
  background-color: #cbd5e1;
  cursor: not-allowed;
}

/* ================= 滚动条美化 ================= */
.chat-body::-webkit-scrollbar {
  width: 5px;
}
.chat-body::-webkit-scrollbar-thumb {
  background: #e2e8f0;
  border-radius: 3px;
}
.chat-body::-webkit-scrollbar-track {
  background: transparent;
}

/* ================= Tooltip 辅助样式 ================= */
.custom-tooltip-wrapper {
  display: flex;
  align-items: center;
}
.custom-tooltip-fixed {
  position: fixed;
  z-index: 10001;
  background-color: #333;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  pointer-events: none;
  transform: translate(-50%, -100%);
}
.tooltip-fade-enter-active,
.tooltip-fade-leave-active {
  transition: opacity 0.2s ease;
}
.tooltip-fade-enter-from,
.tooltip-fade-leave-to {
  opacity: 0;
}
</style>